//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    qrCode: {
      type: String,
      value: ''
    }
  },
  methods: {
    click: function click() {
      this.$emit('hide');
    },
    touchmove: function touchmove(event) {
      event.preventDefault();
    },
    noop: function noop(event) {
      event.preventDefault();
    }
  },
  mounted: function mounted() {
    this.$emit('mounted');
  }
};